import * as React from 'react';
import { IBootstrapTableColumnProps } from 'react-bootstrap-table-next';
import { BodyText, DataGrid, NavigationItem } from 'ui-toolkit';
import { ClientUrlFactory } from '../../ui-toolkit/rest/ClientUrlFactory';
import { SwitchClientCompanyActivateButton } from './SwitchClientCompanyActivateButton';
import { IClientCompanyData } from '../../ui-toolkit/orders/interfaces/IClient';

export const ClientsTable: React.FC<{ data: IClientCompanyData[] }> = ({ data }) => {
  const column: IBootstrapTableColumnProps<IClientCompanyData>[] = [
    {
      dataField: 'name',
      text: 'Name',
    },
    {
      dataField: 'id',
      formatter: (_, row) => (
        <BodyText>
          <NavigationItem to={ClientUrlFactory().urlFor.clientCompany(row.id)} text={'View'} isActive={true} isInline />
          <SwitchClientCompanyActivateButton clientCompany={row} />
        </BodyText>
      ),
      text: 'Actions',
    },
  ];

  return <DataGrid columns={column} data={data} keyField="id" />;
};
